<template>
    <div class="main_container">
        <div class="company_main">
            <div class="role_user">
                <div class="allData large">
                    <h3>{{$t('message.UnassignedCompany')}}</h3>
                    <el-table
                            :data="userTableData"
                            :header-cell-style="{'background-color': '#f8f8f9'}"
                            @selection-change="userNotSelection"
                            class="table_border border-top"
                            max-height="400"
                            ref="userNotSearch"
                            stripe
                            v-loading="loading1">
                        <el-table-column
                                type="selection">
                        </el-table-column>
                        <el-table-column
                                :label="$t('message.CompanySAPCode')"
                                prop="CompanySAPCode"
                                width="120">
                        </el-table-column>
                        <el-table-column
                                :label="$t('message.CompanyName')"
                                prop="CompanyName">
                        </el-table-column>
                    </el-table>
                </div>
                <div class="dataBtns">
                    <el-tooltip :content="$t('message.AddTo')" class="item" effect="dark" placement="top">
                        <el-button :disabled="canAdd" @click="addUsers" circle icon="el-icon-arrow-right"></el-button>
                    </el-tooltip>
                    <el-tooltip :content="$t('message.Remove')" class="item" effect="dark" placement="top">
                        <el-button :disabled="canDel" @click="delUsers" circle icon="el-icon-arrow-left"></el-button>
                    </el-tooltip>
                </div>
                <div class="checkedData large">
                    <h3>{{$t('message.AssignedCompany')}}</h3>
                    <el-table
                            :data="userData"
                            :header-cell-style="{'background-color': '#f8f8f9'}"
                            :row-key="row => row.index"
                            @selection-change="userSelection"
                            class="table_border border-top"
                            max-height="400"
                            ref="userSearched"
                            stripe
                            v-loading="loading2">
                        <el-table-column
                                type="selection">
                        </el-table-column>
                        <el-table-column
                                :label="$t('message.CompanySAPCode')"
                                prop="CompanySAPCode"
                                width="120">
                        </el-table-column>
                        <el-table-column
                                :label="$t('message.CompanyName')"
                                prop="CompanyName">
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getLocal} from "../config/mUtils";
    import {GetAuthCompanyList, SetCompanyAuth} from "../api/apiCompany";

    export default {
        name: 'company',
        components: {},
        data() {
            return {
                loading1: false,
                loading2: false,
                userData: [],
                userTableData: [],
                currentPage1: 1,
                pageSize1: 50,
                maxpage1: 0,
                currentPage2: 1,
                pageSize2: 50,
                maxpage2: 0,
                pageStart1: 0,
                pageStart2: 0,
                pageEnd1: 0,
                pageEnd2: 0,
                userSelections: [],
                userNotSelections: [],
                canAdd: true,
                canDel: true,
            }
        },
        created() {
            this.getLanguageResourceForPage();
            this.getUserDataNo();
            this.getUserData();
        },
        mounted() {
        },
        computed: {},
        watch: {},
        methods: {
            // 控制添加按钮
            userNotSelection(val) {
                this.userNotSelections = val;
                if (val.length > 0) {
                    this.canAdd = false;
                } else {
                    this.canAdd = true;
                }
            },
            // 控制取消按钮
            userSelection(val) {
                this.userSelections = val;
                if (val.length > 0) {
                    this.canDel = false;
                } else {
                    this.canDel = true;
                }
            },
            // 获取未授权公司
            async getUserDataNo() {
                this.loading1 = true;
                const crs = await GetAuthCompanyList(
                    0,
                    getLocal('language')
                );
                this.userTableData = [];
                if (crs.error_code === '0') {
                    this.loading1 = false;
                    this.userTableData = crs.data;
                }
            },
            // 获取已授权公司
            async getUserData() {
                this.loading2 = true;
                const crs = await GetAuthCompanyList(
                    1,
                    getLocal('language')
                );
                this.userData = [];
                if (crs.error_code === '0') {
                    this.loading2 = false;
                    this.userData = crs.data;
                }
            },
            // 保存选择
            async saveUsers() {
                let idlists = [];
                this.userNotSelections.forEach(item => {
                    let msg = item.CompanySAPCode;
                    idlists.push(msg);
                });
                const crs = await SetCompanyAuth(
                    idlists[0],
                    1,
                    getLocal('language')
                );
                if (crs.error_code === '0') {
                    this.$refs.userNotSearch.clearSelection();
                    this.$refs.userSearched.clearSelection();
                    this.userNotSelections = [];
                    this.userSelections = [];
                    this.currentPage1 = 1;
                    this.currentPage2 = 1;
                    this.canAdd = true;
                    this.getUserDataNo();
                    this.getUserData();
                }
            },
            // 添加
            addUsers() {
                this.saveUsers();
            },
            // 删除选择
            async userDelete() {
                let idlists = [];
                this.userSelections.forEach(item => {
                    let msg = item.CompanySAPCode;
                    idlists.push(msg);
                });
                const crs = await SetCompanyAuth(
                    idlists[0],
                    0,
                    getLocal('language')
                );
                if (crs.error_code === '0') {
                    this.$refs.userNotSearch.clearSelection();
                    this.$refs.userSearched.clearSelection();
                    this.userNotSelections = [];
                    this.userSelections = [];
                    this.currentPage1 = 1;
                    this.currentPage2 = 1;
                    this.canAdd = true;
                    this.getUserDataNo();
                    this.getUserData();
                }
            },
            // 去除
            delUsers() {
                this.userDelete();
            },
        }
    }
</script>

<style scoped>

</style>
